import { FaTimes } from 'react-icons/fa'

const Drink = ({ drink, onDelete }) => {
    return (
        <div>
            <ul className='grid grid-cols-5 h-auto w-auto p-2 border-2'>
                <li>{drink.firstInput}</li>
                <li>{drink.secondInput}</li>
                <li>{drink.thirdInput}</li>
                <li>{drink.fourthInput}</li>
                <FaTimes style={{ color:'red', cursor:'pointer',}} 
                onClick={()=> onDelete(drink.id)} />
            </ul>
        </div>
    )
}

export default Drink